function LayoutReducer(state, action) {
  const { field, value } = action.payload;
  const spreadState = state?.[field] || [];

  switch (action.type) {
    case 'layout':
      return { ...state, [field]: { ...spreadState, ...value } };

    default:
      return state;
  }
}
export default LayoutReducer;
